/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-loop-func */
import React from 'react';
// import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';

// import { axios } from '../../../../../v5/utils/axios';
// import { ReadAPIParams, success, successAPI, errorAPI } from '../../../../../v5/utils/utils';
// import Yup from '../../../../../v5/utils/yup';
// import {  } from '../../../../../v5/utils/enums';

// import GoogleMap, { addRoute, clearRoute } from '../../../../../v5/components/googleMap/GoogleMap.jsx';


interface InitState {
  show: boolean,
  values: any,
  coordinates: Array<any>,
}


function NewReducer() {
  const name = 'jobFormJobSummarySlice';


  const initialState: InitState = {
    show: false,
    values: null,
    coordinates: [],
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setShow: (state: InitState, action: PayloadAction<{ show: boolean, values: any, coordinates: Array<any> }>) => {
      state.show = action.payload.show;
      state.values = action.payload.values;
      state.coordinates = action.payload.coordinates;
    },
  };


  const apis = {
    
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();